<template>
	<div class="TUI-ImageMessage" @tap="predivImage">
      <el-image
      style="width: 140px; height: 140px"
      :src="renderDom[0].src"
      fit="fill" lazy
       :preview-src-list="renderDom.map(t=>t.src)"></el-image>
	</div>
</template>

<script>
import { parseImage } from '../../../base/message-facade';

export default {
	data() {
		return {
			renderDom: [],
			percent: 0
		};
	},

	components: {},
	props: {
		message: {
			type: Object,
			default: ''
		},
		isMine: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		message: {
			handler: function(newVal) {
				this.renderDom = parseImage(newVal)
					this.percent = newVal.percent
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		loaded(res){
			this.$emit('loaded',res)
		},
		predivImage() {
			uni.predivImage({
				current: this.renderDom[0].src,
				// 当前显示图片的http链接
				urls: [this.renderDom[0].src]
			});
		}
	}
};
</script>
<style>
.TUI-ImageMessage {
	width: 150px;
}

.image-message {
	width: 100%;
	height: 100%;
	border-radius: 10px 10px 10px 10px;
}

.my-image {
	border-radius: 10px 2px 10px 10px;
}

</style>
